import React from 'react';
import { Paper, Grid, Typography, Stack, Chip } from '@mui/material';

const DeptInfo = ({ depart, checkedRoles }) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: 1,
        px: 2,
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            부서명
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.dptNm}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            부서 이메일
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.emlAddr}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            관리자명
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.leaderNm ? depart?.leaderNm : '-'}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            역할
          </Typography>
        </Grid>
        <Grid item xs={10}>
          {checkedRoles.map((role) => (
            <Typography variant="body2" component="block" sx={{ mr: 1 }}>
              {role}
            </Typography>
          ))}
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            기타1
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.ectVal1}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            기타2
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.ectVal2}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            기타3
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.ectVal3}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            통계병합부서
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.statMerge}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            참조사항
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.dptDesc}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            사용 유무
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {depart?.useYn}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            생성자
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" component="div">
            {depart?.crtNm}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            생성일
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" component="div">
            {depart?.crtDt}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            상위부서
          </Typography>
        </Grid>
        <Grid item xs={10}>
          {!depart?.parentDptNm && (
            <Chip label="회사" variant="outlined" />
          )}
          {depart?.parentDptNm && (
            <Chip label={depart?.parentDptNm} variant="outlined" />
          )}
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            하위부서
          </Typography>
        </Grid>
        <Grid item xs={10}>
          {depart?.children && depart?.children.length > 0 && (
            <Stack direction="row" spacing={1}>
              {depart?.children.map((child, index) => (
                <Chip key={index} label={child?.dptNm} variant="outlined" />
              ))}
            </Stack>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DeptInfo;
